<template>
  <div class="flex flex-col items-center gap-2">
    <img src="/assets/images/enhance/No Records.jpg" alt="No Records" width="120" height="120" loading="lazy" />
    <span class="Roboto-14 text-text-gray">{{ $t("enhance-No-Records") }}</span>
  </div>
</template>
